import React from 'react';
import { motion, useTransform, MotionValue } from 'framer-motion';
import ShinyText from './ShinyText';
import ScrollFloat from './ScrollFloat';

interface AdvancedMorphingTextProps {
  scrollY: MotionValue<number>;
}

export const AdvancedMorphingText: React.FC<AdvancedMorphingTextProps> = ({ scrollY }) => {
  // Transform values for fading the hero text
  const maxScroll = 400;
  
  // Hero text animations - only fade, no morphing
  const heroOpacity = useTransform(scrollY, [0, maxScroll], [1, 0]);
  const heroY = useTransform(scrollY, [0, maxScroll], [0, -40]);

  return (
    <>
      {/* Hero Text - Large and Centered - Fades away */}
      <motion.div
        style={{
          opacity: heroOpacity,
          y: heroY,
        }}
        transition={{
          type: "spring",
          stiffness: 100,
          damping: 30,
          mass: 0.5
        }}
        className="fixed inset-0 flex items-center justify-center pointer-events-none z-30 will-change-transform"
      >
        <div className="text-center">
          <ShinyText 
            text="ARCHXVE" 
            speed={3}
            className="text-[12rem] md:text-[16rem] font-black tracking-wider"
          />
        </div>
      </motion.div>
    </>
  );
};

export const ProfileText: React.FC = () => {
  return (
    <div className="w-full text-center relative z-10 mb-2">
      <ScrollFloat
        containerClassName="!my-0"
        textClassName="font-black tracking-wider text-white"
        animationDuration={1}
        ease="back.out(1.7)"
        scrollStart="top 80%"
        scrollEnd="top 30%"
        stagger={0.05}
      >
        ARCHXVE
      </ScrollFloat>
    </div>
  );
};

export default AdvancedMorphingText;
